import React, { use, useEffect, useState } from 'react';
import BsModal from '../Common/BsModal';
import { useAccounts } from '../../DataStore/AccountsContext';
import TextInput from '../Common/TextInput';
import CallOut from '../Common/CallOut';
import Notification from '../Common/Notification';
import ajaxAsset from '../../util/remote/ajaxAsset';

const MoveLedgerModal = ({ show, onClose, accountInfo, entries }) => {
    const [loading, setLoading] = useState(false);
    const {paymentAccountListing, getPaymentAccounts} = useAccounts();
    const [paymentAccount, setPaymentAccount] = useState(""); 
    const [info, setInfo] = useState(null);

    useEffect(()=>{
        getPaymentAccounts();
    }, []);

    useEffect(()=>{
        if(!show){
            setPaymentAccount("");
            setInfo(null);
        }
    }, [show]);

    const handleSave = async() => {
      if(!paymentAccount){
          setInfo(<Notification message="Please select the destination account to proceed." type="danger"/>);
          return;
      }
      if(entries.length === 0){
            setInfo(<Notification message="No ledger entries selected to move." type="info"/>);
            return;
      }
      setLoading(true);
      const server_response = await ajaxAsset.postMultiContras({payment_account: paymentAccount, ledgers: entries});
        setLoading(false);
        if(server_response.status === "OK"){
            setInfo(<Notification message={server_response.message} type="success" />);
        }else{
            setInfo(<Notification message={server_response.message} type="danger" />);
        }
    }


    const RenderPaymentAccount = () => {
    
            
                const options=[];
                if(Array.isArray(paymentAccountListing))
                {
                    paymentAccountListing.map((item, key)=>
                        options.push({label:item.account_number + ' ' + item.account_name, value:item.account_id})
                    )
                }
                return(
                    <TextInput
                        type="select"
                        label="Destination Account"
                        placeholder="Select Account"
                        leftIcon="fa fa-bank"
                        options={options}
                        onChange={(item)=>setPaymentAccount(item.value)}
                        leftComponent={<i className="fa fa-bank link" onClick={()=>getPaymentAccounts(true)}></i>}
                        loading={!paymentAccountListing}
                        required
                        wrap
                        value={paymentAccount}
                />
        
                )
          }

    return (
    <BsModal
      show={show}
      onClose={onClose}
      title="Perform Contra"
      size="modal-lg"
      footer={
        
          <>
            <button type="button" className="btn btn-modern-secondary" onClick={onClose} disabled={loading}>
              Close
            </button>

          <button type="button" className="btn btn-modern-primary" onClick={handleSave} disabled={loading}>
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm mr-2" />
                Saving...
              </>
            ) : (
              <>
                <i className="fa fa-check-circle mr-2"></i> Execute Contra
              </>
            )}
          </button>
        </>
      }
    >
      <div style={{ padding: '8px' }}>

         <CallOut 
                title={`Contra from ${accountInfo.account_name}`} 
                description={`Performing a contra will move selected ledger entries to the selected destination account. Please note that only debit entries will be moved - crediting ${accountInfo.account_name} and debiting the selected destination account on the same transaction date.`}/>

            <div className='mt-3'> {info} </div>
            <form className="form-horizontal" method="post" onSubmit={handleSave}>

                {RenderPaymentAccount()}
            </form>

      </div>
    </BsModal>
    );
};

export default MoveLedgerModal;